<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>
            <div>콘첸츠 정보</div>
          </strong>
        </div>

        <div v-if="isLoading" sm="12">
          <div class="text-center toploadingbar" style="margin:300px 0 180px 0">
            <div style="width:200px; margin:0 auto; vertical-align:middle">
              <b-spinner label="Large Spinner" style="vertical-align:middle"></b-spinner>
              <span style="vertical-align:middle; padding:5px; font-weight:blod; font-size:20px">Loading...</span>
            </div>
          </div>
        </div>

        <div v-else class="table-responsive-sm">
          <table class="table">
            <tbody>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">(주)카테고리</th>
              <td class="text-center" colspan="2">{{reportInfoItems.main_cate_nm1}}</td>
              <td class="text-center" style="width:50%;">{{reportInfoItems.main_cate_nm2}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">(부)카테고리</th>
              <td class="text-center" colspan="2">{{reportInfoItems.sub_cate_nm1}}</td>
              <td class="text-center">{{reportInfoItems.sub_cate_nm1}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">보고서코드</th>
              <td>{{reportInfoItems.dr_code}}</td>
              <th scope="row" class="bg-light text-center" style="width:150px;">판매구분</th>
              <td>{{reportInfoItems.sales_name}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">보고서명</th>
              <td colspan="3">{{reportInfoItems.report_name}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">부제목</th>
              <td colspan="3">{{reportInfoItems.sub_report_name}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">등록자</th>
              <td colspan="3">{{reportInfoItems.reg_name}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">금액</th>
              <td>{{ reportInfoItems.min_price }}원 ~ {{ reportInfoItems.max_price }}</td>
              <th scope="row" class="bg-light text-center" style="width:150px;">노출여부</th>
              <td>{{reportInfoItems.view_name}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">출시일</th>
              <td>{{reportInfoItems.custom_date}}</td>
              <th scope="row" class="bg-light text-center" style="width:150px;">등록일</th>
              <td>{{reportInfoItems.reg_date}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">조회수</th>
              <td>{{reportInfoItems.total_view_cnt}}</td>
              <th scope="row" class="bg-light text-center" style="width:150px;">추천수</th>
              <td>{{reportInfoItems.total_reco_cnt}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">다운로드수</th>
              <td>{{reportInfoItems.total_dl_cnt}}</td>
              <th scope="row" class="bg-light text-center" style="width:150px;">후속연구요청수</th>
              <td>{{reportInfoItems.total_research_cnt}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>


export default {
  name: 'DrInfoTop',
  data () {
    return {
      isLoading: true,
      reportInfoItems: {},
      reportcode: '',
    }
  },
  mounted() {

    this.contentStatisticsTopInfo();
  },
  methods: {
    contentStatisticsTopInfo(){
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.reportcode = self.$session.get('reportDrcode');
      self.$http.get('/api/select/contentStatisticsTopInfo?access_token=' + token + '&reportcode=' + self.reportcode)
        .then((result) => {
          self.reportInfoItems = result.data;
          self.isLoading = false;
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/statistics/content/component/DrInfo/DrInfoTop.vue